module.exports = __webpack_public_path__ + "img/xlsx1.2f9796d3.png";